import { Static, TLiteral, TUnion } from '@sinclair/typebox';

export const convertUnionToArray = <T extends TUnion<TLiteral[]>>(
    union: T
): Static<T>[] => union.anyOf.map((x) => x.const);
